module.exports = __webpack_public_path__ + "img/souvenier-4.271de3a1.png";